/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LineString } from './LineString';
import type { MultiLineString } from './MultiLineString';
import type { MultiPoint } from './MultiPoint';
import type { MultiPolygon } from './MultiPolygon';
import type { Point } from './Point';
import type { Polygon } from './Polygon';

export type GeometryCollection = {
    type: GeometryCollection.type;
    geometries: Array<(Point | LineString | Polygon | MultiPoint | MultiLineString | MultiPolygon)>;
    bbox?: Array<number>;
};

export namespace GeometryCollection {

    export enum type {
        GEOMETRY_COLLECTION = 'GeometryCollection',
    }


}

